























































import Vue from "vue";

// Model
import { MODULE_COLORS } from "@/utility/Constants";
import { TunnelProtocolEnum, TunnelProtocolEnumToString } from "@/model/data/enums/TunnelProtocolEnum";
import { FetchInstallationsRemoteLinkStatusReqData } from "@/model/communication/remoteLink/FetchInstallationsRemoteLinkStatusCommand";

export default Vue.extend({
    props: {
        totalActiveSession: {
            required: true,
            type: Number,
        },
        totalInactiveSession: {
            required: true,
            type: Number,
        },
        loading: {
            required: true,
            type: Boolean,
        },
        reqData: {
            type: Object as () => FetchInstallationsRemoteLinkStatusReqData,
        },
    },
    data() {
        return {
            firstTime: true,
            MODULE_COLORS,
        };
    },
    computed: {},
    watch: {
        loading(newValue) {
            if (!newValue) this.firstTime = false;
        },
    },
    methods: {
        TunnelProtocolEnumToString,
        getIconForProtocol(protocol: TunnelProtocolEnum) {
            switch (protocol) {
                case TunnelProtocolEnum.SSH:
                    return "terminal";
                case TunnelProtocolEnum.HTTP:
                    return "globe";
                case TunnelProtocolEnum.HTTPS:
                    return "globe";
                case TunnelProtocolEnum.UltraVNC:
                    return "desktop";
                case TunnelProtocolEnum.CService:
                    return "tools";
                case TunnelProtocolEnum.CaosDB:
                    return "database";
            }
        },
        toggleFilter(sessionFilter: number) {
            let newReqData = Object.assign({}, this.reqData);
            newReqData.offset = 0;
            if (this.reqData.sessionFilter == sessionFilter) newReqData.sessionFilter = -1;
            else newReqData.sessionFilter = sessionFilter;
            this.$emit("send-request", newReqData);
        },
    },
});
